// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd

import {Injectable, EventEmitter} from '@angular/core';

export interface DragDropData {
  dragData: any;
  mouseEvent: MouseEvent;
}

export function dragDropServiceFactory(): DragDropService  {
  return new DragDropService();
}

@Injectable()
export class DragDropService {
  allowedDropZones: Array<string> = [];
  dragSuccessEmitter: EventEmitter<DragDropData>;
  dragData: any;
  isDragged: boolean;
}
